function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import { ArrowDownIcon, ArrowUpIcon } from "@cxagroup/casper-icons";

var ToggleArrow = function ToggleArrow(_ref) {
  var _ref$isActive = _ref.isActive,
      isActive = _ref$isActive === undefined ? false : _ref$isActive,
      props = _objectWithoutProperties(_ref, ["isActive"]);

  var Arrow = isActive ? ArrowUpIcon : ArrowDownIcon;
  return React.createElement(Arrow, props);
};

ToggleArrow.propTypes = process.env.NODE_ENV !== "production" ? {
  isActive: PropTypes.bool
} : {};

export default ToggleArrow;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/toggle-arrow/ToggleArrow.js
// module id = null
// module chunks = 